// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1fvXg","footer":"ModalInfo_footer__ln46x"};